import { I18n } from '@calendly/i18n';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CloseIcon } from '@calendly/ui/components/icons';
import { Loader } from '@calendly/ui/components/loader';
import { Modal } from '@calendly/ui/components/modal';
import { Sheet } from '@calendly/ui/components/sheet';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFetchEligibilityQuery, useFetchRequestableOrgsQuery } from './api';
import { ExistingRequestStep } from './existing_request_step';
import { OrgList } from './org_list';
import { isSeatRequestModalOnSubmitStepSelector, isSeatRequestModalOpenSelector, seatRequestBannerOpenedFromSelector } from './selectors';
import { closeSeatRequestModal } from './slice';
import { ModalTitle } from './styles';
import { SubmitStep } from './submit_step';
import { TRACKING_EVENT_NAMES, useTrack } from '../../hooks/analytics_events';
import { useSeatRequestExperimentEnabled } from '../../hooks/growth_experiments/use-seat-request-experiment';
const customSheetCss = "c1ub91ba";
const CustomSheet = forwardRef((props, ref) => <Sheet ref={ref} {...props} className={classNames(customSheetCss, props.className)} />);
const dividerCss = "dsi8w6m";
const Divider = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dividerCss, props.className)} />;
});
const closeButtonWrapperCss = "ckrmkph";
const CloseButtonWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(closeButtonWrapperCss, props.className)} />;
});
const subtitleCss = "sh7w0tk";
const Subtitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(subtitleCss, props.className)} />;
});
const CloseButton = ({
  step
}) => {
  const dispatch = useDispatch();
  const track = useTrack();
  const openedFrom = useSelector(seatRequestBannerOpenedFromSelector);
  return <CloseButtonWrapper>
      <IconButton onClick={() => {
      track({
        name: TRACKING_EVENT_NAMES.MODAL_INTERACTION,
        properties: {
          action: 'dismissed',
          modal_name: step === 'first_step' ? 'join_existing_org' : 'connect_with_existing_org',
          modal_details: step === 'first_step' ? 'join_with_your_organization' : 'send_an_email_request',
          location: openedFrom,
          path: window.location.pathname
        }
      });
      dispatch(closeSeatRequestModal());
    }} title="">
        <CloseIcon />
      </IconButton>
    </CloseButtonWrapper>;
};
const OrgListStep = () => {
  const dispatch = useDispatch();
  const {
    isLoading,
    data,
    isError
  } = useFetchRequestableOrgsQuery();
  const {
    isLoading: isEligibilityLoading,
    data: eligibilityData,
    isError: isEligibilityError,
    refetch: refetchEligibility
  } = useFetchEligibilityQuery();
  if (isEligibilityLoading || isEligibilityError) return <Loader />;
  // Just show loader indefinitely if there's an error... should NOT happen, user will still see "Server error"

  if (eligibilityData?.existingRequest) return <ExistingRequestStep />;
  if (data?.collection?.length === 0) {
    refetchEligibility();
    dispatch(closeSeatRequestModal());
    return null;
  }
  return <>
      <ModalTitle>
        {I18n.t('publisher.growth_experiments.seat_requests.request_modal.title')}
      </ModalTitle>
      <Subtitle>
        {I18n.t('publisher.growth_experiments.seat_requests.request_modal.subtitle')}
      </Subtitle>

      <Divider />

      {isError ? <Loader size="small" /> : <OrgList loading={isLoading} collection={data?.collection} />}
    </>;
};
const ModalContent = () => {
  const isOnSubmitStep = useSelector(isSeatRequestModalOnSubmitStepSelector);
  return <Modal>
      <CustomSheet>
        <CloseButton step={isOnSubmitStep ? 'submit_step' : 'first_step'} />

        {isOnSubmitStep ? <SubmitStep /> : <OrgListStep />}
      </CustomSheet>
    </Modal>;
};
export const SeatRequestModal = () => {
  const seatRequestExperimentEnabled = useSeatRequestExperimentEnabled();
  const isSeatRequestModalOpen = useSelector(isSeatRequestModalOpenSelector);
  if (!seatRequestExperimentEnabled || !isSeatRequestModalOpen) return null;
  return <ModalContent />;
};

require("./seat_request_modal.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./seat_request_modal.js");